import { createRoot } from 'react-dom/client';
import ChariotGivingWrapper from './ChariotGivingWrapper';

$(() => {
    const connectIdElement = document.getElementById('js-connectid');
    const connectId = JSON.parse(connectIdElement.textContent);
    const userElement = document.getElementById('js-loggedin-user');
    const user = JSON.parse(userElement.textContent);

    // Should be set via pageSpecificJsVariables
    const useChariot = !!window.useChariot;
    const hasExistingUser = !!window.hasExistingUser;

    const root = createRoot(document.getElementById('react-dafGivingHub'));
    root.render(<ChariotGivingWrapper connectId={connectId}
        loggedInUser={user}
        useChariot={useChariot}
        hasExistingUser={hasExistingUser}
    />);
});
